module.exports = __webpack_public_path__ + "img/sp-tre-fiori.67a0e751.png";